/*
 * Author: Housefolios
 * Create Time: 2021-11-22 08:46:15
 * @ Modified by: David Helmick
 * @ Modified time: 2025-09-03 17:52:07
 * Description: Dialog to delete a portfolio - Refactored to use generic DeleteConfirmationDialog
 */

import React from 'react'
import { ListItem } from '@mui/material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import { useMutation, useQuery } from '@apollo/client/react'
import { DELETE_PORTFOLIO } from '../mutations'
import { GET_ORGS_PORTFOLIO_SHARED_WITH } from '../queries'
import { GET_PORTFOLIOS } from '@/housefolios-pages/Launchpad/queries'
import { GET_SIDEBAR_PORTFOLIOS } from '@/housefolios-components/Portfolio/queries'
import { GET_ME } from '@/housefolios-components/Session/queries'
import { GET_TRASH } from '@/housefolios-components/Properties/queries'
import { useNavigate } from 'react-router'
import DeleteConfirmationDialog from '@/housefolios-components/Common/DeleteConfirmationDialog'
import { useDeleteConfirmation } from '@/housefolios-components/Common/DeleteConfirmationDialog/useDeleteConfirmation'

// Centralized lodash imports - much cleaner!
import { includes } from '@/utils/lodash'

function DeletePortfolioComponent(props) {
  const { sidebarMenu, portfolio = {} } = props
  const navigate = useNavigate()

  const [deletePortfolio] = useMutation(DELETE_PORTFOLIO)

  const { data, loading, error } = useQuery(
    GET_ORGS_PORTFOLIO_SHARED_WITH,
    {
      variables: {
        portfolioId: portfolio._id,
      },
    },
  )

  const {
    open,
    loading: deleteLoading,
    openDialog,
    closeDialog,
    handleDelete,
  } = useDeleteConfirmation({
    onDelete: async () => {
      const properyCheck = includes(
        window.location.href,
        'property-details',
      )

      await deletePortfolio({
        variables: {
          id: portfolio._id,
          deleteProperties: true,
          deleteCommercial: true,
          deleteInvestors: true,
          deleteLots: true,
        },
        refetchQueries: [
          { query: GET_PORTFOLIOS },
          { query: GET_SIDEBAR_PORTFOLIOS },
          { query: GET_TRASH },
          { query: GET_ME },
        ],
      })

      if (properyCheck) navigate('/my-properties')
      props.handleClose()
    },
    successMessage: `${portfolio.name} and all its associated data (properties, commercial properties, investors, lots) have been deleted`,
    errorMessage: `Failed to Delete Portfolio`,
  })

  if (loading) return 'loading'
  if (error) return `Error! ${error.message}`

  const { orgsPortfolioSharedWith } = data
  const isShared = orgsPortfolioSharedWith.length > 0

  return (
    <>
      {sidebarMenu && (
        <ListItem component="div" onClick={openDialog}>
          <DeleteOutlinedIcon
            style={{ marginRight: 5, color: 'red' }}
          />
          <span style={{ color: 'red' }}>Delete Portfolio</span>
        </ListItem>
      )}

      <DeleteConfirmationDialog
        open={open}
        onClose={closeDialog}
        onConfirm={handleDelete}
        title="Delete Portfolio?"
        confirmationText={
          isShared
            ? 'Delete this shared portfolio and all its associated data (properties, commercial properties, investors, lots). This action cannot be undone.'
            : 'Delete this portfolio and all its associated data (properties, commercial properties, investors, lots). This action cannot be undone.'
        }
        successMessage={`${portfolio.name} and all its associated data (properties, commercial properties, investors, lots) have been deleted`}
        errorMessage="Failed to Delete Portfolio"
        loading={deleteLoading}
        loadingMessage="Deleting Portfolio"
        showSharedWarning={isShared}
        sharedWarningText="This portfolio is shared with others"
        icon="trash-can"
        iconStyle="fas"
        cancelButtonText="Cancel"
        deleteButtonText="Delete"
        requireConfirmation={true}
        children={null}
      />
    </>
  )
}

export default DeletePortfolioComponent
